import { Cancel } from 'iconoir-react'
import React, {useState} from 'react'
import { generatePromoCode } from '../../../utils'
import Button from '../Button'
import BasicDropDown from '../dropdowns/BasicDropDown'
import InputField from '../InputField'

const RefundModal = ({onCancel, onSubmit, user}) => {
  const [details, setDetails] = useState({})
  const [isActive, setIsActive] = useState({credit: false, promo: false});

  return (
    <div className="fixed z-20 inset-0 overflow-y-auto">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity">
          <div className="absolute inset-0 bg-gray-900 bg-opacity-75"></div>
        </div>
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;
        <div className="inline-block p-5 align-bottom w-2/6 rounded-lg bg-white text-left overflow-hidden shadow-xl transform transition-all sm:my-12 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
          <label className='flex justify-between mb-5'>
            <h1 className='text-lg wayrideColor font-bold'>Refunds</h1>
            <Cancel onClick={onCancel} className='cursor-pointer bg-gray-300 rounded-full text-gray-900 h-7 w-7 p-1' />
          </label>
          <div className='my-5'>
            <span className="text-gray-500 text-sm dark:text-gray-400">Refund with:</span>
            <BasicDropDown 
              size={'small'}
              onSelect={(e)=>{
                const { value } = e.target;
                if(value === 'Promotion Discount'){
                  setDetails({
                    user_id: user.id,
                    ...details, total_usage: 1, promo_type: 'Value',
                    promo_code: `Rf${generatePromoCode()}`
                  })
                  setIsActive({credit: false, promo: true});                  
                  // ToastMessage({message: `Kindly add a promo discount to ${user.other_names}`})
                  // navigator(`/promotions/create?user${user.id}`, {state: user});
                }else if('Ride credit'){
                  setIsActive({credit: true, promo: false});                  
                }
              }}    
              items={['Ride credit', 'Promotion Discount']}
            />
          </div>
          {isActive.credit &&          
            <div className='my-5'>
              <span className="text-gray-500 text-sm dark:text-gray-400">
                Enter Ride credit amount in GHC
              </span>
              <InputField 
                size={'small'}
                onChange={(e)=>{
                  const { value } = e.target;
                  setDetails({...details, amount: value})
                }}
                value={details.ride_credit_amt}              
              />
            </div>
          }
          {isActive.promo &&          
            <div className='my-5'>
              <span className="text-gray-500 text-sm dark:text-gray-400">
                Promotion code (auto-generated) 
              </span>
              <InputField 
                type={'text'}
                name="promo_code"
                size={'small'}
                isRequired={true}
                onChange={(e)=>{
                  const { value } = e.target;
                  setDetails({...details, promo_code: value})
                }}
                value={details.promo_code}
              />
              <br />
              <br />
              <span className="text-gray-500 text-sm dark:text-gray-400">
                Enter Promotion amount in GHC
              </span>
              <InputField 
                size={'small'}
                onChange={(e)=>{
                  const { value } = e.target;
                  setDetails({...details, value})
                }}
                value={details.value}              
              />
            </div>
          }
          <Button
            label={'Submit'}
            width="w-full"
            onClick={()=>onSubmit(details, isActive)}
            bgColor={'wayrideBgColor'}
          />
        </div>
      </div>
    </div>
  )
}

export default RefundModal